import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LocationDetailContainerComponent } from './components/location-detail-container/location-detail-container.component';

const routes: Routes = [
  {
    path: '',
    component: LocationDetailContainerComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LocationDetailsRoutingModule {}
